module.exports = __webpack_public_path__ + "img/6.c016ede0.jpg";